import addInfoBarMessage from 'owa-info-bar/lib/actions/addInfoBarMessage';
import { InfoBarHostViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { IEditor, GetContentMode } from 'roosterjs-editor-types';

const DISABLE_PROOFING_BODY_LENGTH_THESHOLD = 15000;

export function disableProofingBasedOnLength(
    editor: IEditor | undefined,
    infoBarHostViewState: InfoBarHostViewState
): boolean {
    const content: string = editor?.getContent(GetContentMode.PlainText);
    const disableProofingBasedOnLength: boolean =
        content?.length > DISABLE_PROOFING_BODY_LENGTH_THESHOLD;
    if (disableProofingBasedOnLength) {
        addInfoBarMessage(infoBarHostViewState, 'proofingDiabledDueToSize');
    }
    return disableProofingBasedOnLength;
}
